import { TOAST_IDS, ToastType } from "@/modules/common/types";
import { showToast } from "@/modules/common/utils";
import { useLeadContext } from "@/modules/lead-page/context/lead-page.context";
import { queryClient } from "@/queryClient";
import { useMutation } from '@tanstack/react-query';
import { deleteLeadTag } from "@/modules/lead-page/api/lead-page.v2.api";
import { useState } from "react";
const useLeadTagList = () => {
  const { lead } = useLeadContext();
  const [openEditModal, setOpenEditModal] = useState(false);

  const {
    mutate: removeLeadTag,
    isLoading: isRemovingTag,
    variables: removeTagVariables,
  } = useMutation(
    ({ leadUId, leadTagUId }: { leadUId: string; leadTagUId: string }) =>
      deleteLeadTag(leadUId, leadTagUId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["getLead"] });
        showToast({
          type: ToastType.SUCCESS,
          toastId: TOAST_IDS.DELETE_LEAD_TAG_SUCCESS,
          message: "Tag removed successfully",
          options: {
            position: "bottom-left",
            autoClose: 3000,
          },
        });
        setOpenEditModal(false);
      },
      onError: () => {
        showToast({
          type: ToastType.ERROR,
          toastId: TOAST_IDS.DELETE_LEAD_TAG_ERROR,
          message: "Failed to remove tag",
          options: {
            position: "bottom-left",
            autoClose: 3000,
          },
        });
      },
    }
  );

  return {
    removeLeadTag,
    isRemovingTag,
    lead,
    openEditModal,
    setOpenEditModal,
    removeTagVariables,
  };
};

export default useLeadTagList;
